<template>
  <div>
    <div
      v-if="
        baseView.mode == 'create' &&
        createModeIsEditMode == false &&
        viewMode == null
      "
    >
      <span :title="'Create ' + title">
        <span class="text-primary ml-xs">Create {{ title }}</span>
      </span>
    </div>
    <div
      v-if="
        (baseView.mode == 'edit' || createModeIsEditMode) &&
        baseView.mode != 'review' &&
        viewMode == null
      "
    >
      <span :title="primaryLabel + ' ' + secondaryLabel">
        <span class="text-primary ml-xs">{{ primaryLabel }}</span>
        <span class="text-secondary ml-sm">{{ secondaryLabel }}</span>
      </span>
    </div>
    <div v-if="baseView.mode == 'review' && viewMode == null">
      <span :title="primaryLabel + ' ' + secondaryLabel">
        <span class="text-primary ml-xs">{{ primaryLabel }}</span>
        <span class="text-secondary ml-sm">{{ secondaryLabel }}</span>
      </span>
    </div>
    <div v-if="viewMode == 'popup'">
      <span :title="primaryLabel + ' ' + secondaryLabel">
        <span class="text-primary ml-xs">{{ primaryLabel }}</span>
        <span class="text-secondary ml-sm">{{ secondaryLabel }}</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    baseView: Object,
    primaryLabel: {
      type: String,
      default: "",
    },
    secondaryLabel: {
      type: null,
      default: "",
    },
    recordType: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    createModeIsEditMode: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: null,
      default: null,
    },
  },
  data() {
    return {};
  },
  mounted() {
    if(this.recordType && this.primaryLabel && this.secondaryLabel)
    document.title = `${this.recordType} - ${this.primaryLabel} ${this.secondaryLabel}`

    if(!this.recordType && this.primaryLabel && this.secondaryLabel)
    document.title = `${this.primaryLabel} ${this.secondaryLabel}`

    if(!this.recordType && this.primaryLabel && !this.secondaryLabel)
    document.title = this.primaryLabel

    if(this.recordType && !this.primaryLabel && !this.secondaryLabel)
    document.title = this.recordType
  },
  updated(){
    if(this.recordType && this.primaryLabel && this.secondaryLabel)
    document.title = `${this.recordType} - ${this.primaryLabel} ${this.secondaryLabel}`

    if(!this.recordType && this.primaryLabel && this.secondaryLabel)
    document.title = `${this.primaryLabel} ${this.secondaryLabel}`

    if(!this.recordType && this.primaryLabel && !this.secondaryLabel)
    document.title = this.primaryLabel

    if(this.recordType && !this.primaryLabel && !this.secondaryLabel)
    document.title = this.recordType
  }
};
</script>
